import { GlobalPageLoadExperience } from '@atlassian/ufo';

export const pageViewStart = (pageName: string) => {
  GlobalPageLoadExperience.startPageLoad(pageName);
};
export const pageViewSuccess = () => {
  GlobalPageLoadExperience.success({ force: true });
};
